import { EnvService } from './env.service';

export const EnvServiceFactory = () => {
    
    const appConfig = new EnvService();

    const browserWindow = window || {};
    const browserWindowEnv = browserWindow['__appConfig'] || {};

    for (const key in browserWindowEnv) {
        if (browserWindowEnv.hasOwnProperty(key)) {
            appConfig[key] = window['__appConfig'][key];
        }
    }

    return appConfig;
};

export const EnvServiceProvider = {
    provide: EnvService,
    useFactory: EnvServiceFactory,
    deps: [],
}